import { Check, Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { LANGUAGES } from "@/i18n/translations";
import { useLang } from "@/context/LanguageContext";

export function LanguageSelector() {
  const { lang, setLang, t, isRTL } = useLang();
  const current = LANGUAGES.find((l) => l.code === lang);
  return (
    <DropdownMenu dir={isRTL ? "rtl" : "ltr"}>
      <DropdownMenuTrigger asChild>
        <button
          className="flex h-10 items-center gap-1.5 rounded-full border border-border bg-card px-3 text-sm font-semibold shadow-soft transition-colors hover:border-primary/40 active:scale-95"
          aria-label={t("selectLanguage")}
          data-testid="language-selector-btn"
        >
          <Globe className="h-4 w-4 text-muted-foreground" />
          <span className="uppercase">{current?.code}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44 rounded-2xl">
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => setLang(l.code)}
            className="flex cursor-pointer items-center gap-2.5 rounded-xl py-2.5"
            data-testid={`language-option-${l.code}`}
          >
            <span className="text-base">{l.flag}</span>
            <span className="flex-1 font-medium">{l.label}</span>
            {lang === l.code && <Check className="h-4 w-4 text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
